import { render, staticRenderFns } from "./clinic_organization_members.vue?vue&type=template&id=5634892f&scoped=true&"
import script from "./clinic_organization_members.vue?vue&type=script&lang=js&"
export * from "./clinic_organization_members.vue?vue&type=script&lang=js&"
import style0 from "./clinic_organization_members.vue?vue&type=style&index=0&id=5634892f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634892f",
  null
  
)

export default component.exports